export default __webpack_public_path__ + "assets/images/b71ee945783aa0c0b89cf07b1fd8e0ee.svg";